export default {
  paginatedBusinesses: {},
};
